import { type CSSProperties } from "react";
import { useTranslation } from "react-i18next";

/**
 * Spisak se nije učitao — i to mora da piše.
 *
 * Do sada je neuspelo učitavanje završavalo kao prazan spisak: greška je otišla u obaveštenje
 * koje nestane za nekoliko sekundi, a na ekranu je ostajalo „Još nema ponuda". Korisnik tako
 * čita ispad servera kao izjavu o svom poslu, i to pogrešnu — u bazi je 108.287 ponuda. Najčešći
 * slučaj je podizanje nove verzije, kad backend nakratko nije tu.
 *
 * Razlika je važnija nego što izgleda: prazan spisak je podatak, neuspelo učitavanje je kvar.
 * Ovde se nudi i ponovni pokušaj, jer je kvar po pravilu prolazan.
 */
export function LoadFailed({ message, onRetry }: { message?: string | null; onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <div style={okvir}>
      <p style={{ margin: 0, color: "var(--ink-2)", fontWeight: 500 }}>
        {t("load.failed.title", "Učitavanje nije uspelo.")}
      </p>
      <p style={{ margin: "6px 0 0", color: "var(--ink-3)", fontSize: 12.5 }}>
        {message || t("load.failed.hint", "Veza sa serverom je prekinuta. Pokušajte ponovo.")}
      </p>
      <button type="button" className="btn sm" style={{ marginTop: 14 }} onClick={onRetry}>
        {t("action.retry", "Pokušaj ponovo")}
      </button>
    </div>
  );
}

const okvir: CSSProperties = {
  display: "flex", flexDirection: "column", alignItems: "center",
  padding: "40px 20px", textAlign: "center",
};
